import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type TrackingState = {
  trackingThematiqueId: number;
  thematiqueName: string;
  siteName: string;
  sessionUuid: string | undefined;
  activityOrder?: number | undefined;
};
type ConnectionState = {
  sessionUuid: string | null;
  setSession: (session: string) => void;

  connectionId: number | null;
  setConnectionId: (connectionId: number) => void;

  currentTrackingThematiqueId: number | null;
  setCurrentTrackingThematiqueId: (
    currentTrackingThematiqueId: number | null
  ) => void;

  currentThematique: string | null;
  setCurrentThematique: (currentThematique: string | null) => void;

  currentSite: string | null;
  setCurrentSite: (currentSite: string | null) => void;

  //currentActivityOrder: number | null;
  // setCurrentActivityOrder: (currentActivityOrder: number | null) => void;

  currentTrackings: TrackingState[];
  setCurrentTrackings: (trackings: TrackingState[]) => void;

  addTracking: (currentTracking: TrackingState) => void;
};

const useConnectionStore = create<ConnectionState>()(
  persist(
    (set) => ({
      sessionUuid: null,
      connectionId: null,
      currentTrackingThematiqueId: null,
      currentTrackings: [],
      currentActivityOrder: null,
      currentThematique: null,
      currentSite: null,
      setSession: (sessionUuid: string) => set({ sessionUuid }),
      setConnectionId: (connectionId: number) => set({ connectionId }),
      setCurrentTrackingThematiqueId: (
        currentTrackingThematiqueId: number | null
      ) => set({ currentTrackingThematiqueId }),
      setCurrentThematique: (currentThematique: string | null) =>
        set({ currentThematique }),
      setCurrentSite: (currentSite: string | null) => set({ currentSite }),
      setCurrentTrackings: (currentTrackings: TrackingState[]) =>
        set({ currentTrackings }),
      // setCurrentActivityOrder: (currentActivityOrder: number | null) =>
      //   set({ currentActivityOrder }),
      addTracking: (currentTracking: TrackingState) => {
        return set((state) => ({
          currentTrackings: [
            ...state.currentTrackings,
            {
              thematiqueName: currentTracking.thematiqueName,
              trackingThematiqueId: currentTracking.trackingThematiqueId,
              siteName: currentTracking.siteName,
              sessionUuid: currentTracking.sessionUuid,
              ...(currentTracking.activityOrder && {
                activityOrder: currentTracking.activityOrder,
              }),
            },
          ],
        }));
      },
    }),
    {
      name: 'connection-storage',
    }
  )
);

export default useConnectionStore;
